<template>
  <div>
    <h1 class="text-xl">Pagina non trovata</h1>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style></style>
